// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-in-test[data-v-9dcc2096] {\n  padding: 20px;\n  background-color: #fff;\n}\n.pay-in-test .result-container[data-v-9dcc2096] {\n  margin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
